import { render, staticRenderFns } from "./TooltipOrDialog.vue?vue&type=template&id=1a6b3de5"
import script from "./TooltipOrDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./TooltipOrDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports